/* PlanetZebi-Universal — storefront behaviour.
   Plain JavaScript, no dependencies. Each feature looks for its own data-*
   hooks and does nothing when they aren't on the page. */
(function () {
  'use strict';

  var PZ = window.PZ || {};
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    var format = PZ.settings.moneyFormat || '${{amount}}';
    function delimit(number, precision, thousands, decimal) {
      var parts = (number / 100).toFixed(precision).split('.');
      return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands) + (parts[1] ? decimal + parts[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return delimit(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return delimit(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delimit(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return delimit(cents, 2, "'", '.');
        case 'amount_with_space_separator': return delimit(cents, 2, ' ', ',');
        default: return delimit(cents, 2, ',', '.');
      }
    });
  }

  /* ---------- Overlays: menu drawer, cart drawer, search ---------- */
  var dimmer = $('[data-dimmer]');
  var openLayer = null;
  var lastFocus = null;

  function openOverlay(el, opener) {
    if (!el) return;
    if (openLayer && openLayer !== el) closeOverlay(true);
    lastFocus = opener || document.activeElement;
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-open'); }); // next frame so the slide-in runs
    if (dimmer) dimmer.hidden = false;
    document.body.classList.add('pz-locked');
    openLayer = el;
    if (opener && opener.hasAttribute('aria-expanded')) opener.setAttribute('aria-expanded', 'true');
    var focusTarget = $('[data-search-input]', el) || $('button, a, input, select', el);
    if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 60);
  }

  function closeOverlay(keepDimmer) {
    if (!openLayer) return;
    var el = openLayer;
    el.classList.remove('is-open');
    setTimeout(function () { if (!el.classList.contains('is-open')) el.hidden = true; }, el.classList.contains('pz-drawer') ? 280 : 0);
    openLayer = null;
    if (!keepDimmer) {
      if (dimmer) dimmer.hidden = true;
      document.body.classList.remove('pz-locked');
    }
    $$('[data-nav-open][aria-expanded="true"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-drawer-close], [data-search-close]') || t === dimmer) {
      e.preventDefault();
      closeOverlay();
      return;
    }
    var navOpen = t.closest('[data-nav-open]');
    if (navOpen) { e.preventDefault(); showPanel('root'); openOverlay($('#NavDrawer'), navOpen); return; }
    var searchOpen = t.closest('[data-search-open]');
    if (searchOpen && $('#SearchOverlay')) { e.preventDefault(); openOverlay($('#SearchOverlay'), searchOpen); return; }
    var cartToggle = t.closest('[data-cart-toggle]');
    if (cartToggle && PZ.settings.cartType === 'drawer' && $('#CartDrawer')) { e.preventDefault(); openOverlay($('#CartDrawer'), cartToggle); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var lb = $('#Lightbox');
    if (lb && !lb.hidden) { closeLightbox(); return; }
    closeOverlay();
    closeAllFlyouts();
  });

  /* ---------- Desktop sidebar flyouts ----------
     Flyouts are position:fixed so the scrolling sidebar can't clip them;
     their position is worked out when they open. */
  var flyoutItems = $$('[data-flyout-item]').filter(function (i) { return $('[data-flyout]', i); });
  var flyoutTimer = null;

  function closeAllFlyouts(except) {
    flyoutItems.forEach(function (item) {
      if (item === except) return;
      item.classList.remove('is-open');
      item.firstElementChild.setAttribute('aria-expanded', 'false');
    });
  }
  function openFlyout(item) {
    closeAllFlyouts(item);
    item.classList.add('is-open'); // must be visible before it can be measured
    item.firstElementChild.setAttribute('aria-expanded', 'true');
    var flyout = $('[data-flyout]', item);
    var margin = 8;
    var rect = item.getBoundingClientRect();
    var left = rect.right;
    if (left + flyout.offsetWidth > window.innerWidth - margin) left = Math.max(margin, rect.left - flyout.offsetWidth);
    flyout.style.left = left + 'px';
    flyout.style.top = Math.max(margin, Math.min(rect.top, window.innerHeight - flyout.offsetHeight - margin)) + 'px';
  }
  flyoutItems.forEach(function (item) {
    item.firstElementChild.addEventListener('click', function (e) {
      e.preventDefault();
      var wasOpen = item.classList.contains('is-open');
      closeAllFlyouts();
      if (!wasOpen) openFlyout(item);
    });
    item.addEventListener('mouseenter', function () { clearTimeout(flyoutTimer); openFlyout(item); });
    item.addEventListener('mouseleave', function () { clearTimeout(flyoutTimer); flyoutTimer = setTimeout(closeAllFlyouts, 200); });
    $('[data-flyout]', item).addEventListener('mouseenter', function () { clearTimeout(flyoutTimer); });
  });
  document.addEventListener('click', function (e) { if (!e.target.closest('[data-flyout-item]')) closeAllFlyouts(); });
  window.addEventListener('resize', function () { closeAllFlyouts(); });

  /* ---------- Mobile menu panels ---------- */
  function showPanel(id) {
    var root = $('[data-mnav]');
    if (!root) return;
    $$('[data-panel]', root).forEach(function (p) { p.classList.toggle('is-open', p.getAttribute('data-panel') === id); });
    root.scrollTop = 0;
  }
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-panel-open]');
    if (!trigger) return;
    e.preventDefault();
    showPanel(trigger.getAttribute('data-panel-open'));
  });

  /* ---------- Auto-submitting selects (country, language, sort) ---------- */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-autosubmit]')) e.target.form.submit();
  });

  /* ---------- Search suggestions ---------- */
  (function () {
    var input = $('[data-search-input]');
    var results = $('[data-search-results]');
    if (!input || !results || !PZ.settings.predictiveSearch) return;
    var timer = null;
    var controller = null;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (!q) { results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        if (controller) controller.abort();
        controller = new AbortController();
        fetch(PZ.routes.predictiveSearch + '?q=' + encodeURIComponent(q) + '&section_id=predictive-search&resources[limit]=6', { signal: controller.signal })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var found = new DOMParser().parseFromString(html, 'text/html').querySelector('.pz-predictive');
            results.innerHTML = found ? found.outerHTML : '';
          })
          .catch(function () {});
      }, 220);
    });
  })();

  /* ---------- Cart ---------- */
  function cartRequest(url, body) {
    if ($('#CartDrawer')) {
      body.sections = 'cart-drawer';
      body.sections_url = window.location.pathname;
    }
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) throw new Error(data.description || data.message || PZ.strings.cartError);
        return data;
      });
    });
  }

  function renderCart(data) {
    var html = data && data.sections && data.sections['cart-drawer'];
    var drawer = $('#CartDrawer');
    if (html && drawer) {
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
      if (fresh) {
        $('[data-cart-contents]', drawer).replaceWith($('[data-cart-contents]', fresh));
        var oldFooter = $('[data-cart-footer]', drawer);
        var newFooter = $('[data-cart-footer]', fresh);
        if (oldFooter) oldFooter.remove();
        if (newFooter) drawer.appendChild(newFooter);
      }
    }
    return fetch(PZ.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (cart) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-product-form]')) return;
    if (PZ.settings.cartType !== 'drawer' || !$('#CartDrawer')) return; // the browser posts to /cart instead
    e.preventDefault();
    var button = $('[data-add-button]', form);
    var error = $('[data-form-error]', form);
    var data = new FormData(form);
    error.hidden = true;
    button.disabled = true;
    cartRequest(PZ.routes.cartAdd + '.js', { items: [{ id: Number(data.get('id')), quantity: Number(data.get('quantity') || 1) }] })
      .then(renderCart)
      .then(function () { openOverlay($('#CartDrawer')); })
      .catch(function (err) { error.textContent = err.message; error.hidden = false; })
      .finally(function () { button.disabled = false; });
  });

  function changeLine(lineEl, qty) {
    var container = lineEl.closest('[data-cart-contents], [data-cart-page]');
    container.classList.add('is-busy');
    cartRequest(PZ.routes.cartChange + '.js', { line: Number(lineEl.getAttribute('data-line')), quantity: Math.max(0, qty) })
      .then(function (data) {
        if (lineEl.closest('[data-cart-page]')) { window.location.reload(); return; }
        return renderCart(data);
      })
      .catch(function (err) { window.alert(err.message); })
      .finally(function () { container.classList.remove('is-busy'); });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-qty]');
    if (!btn) return;
    e.preventDefault();
    changeLine(btn.closest('[data-line]'), Number(btn.getAttribute('data-line-qty')));
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-line-input]')) changeLine(e.target.closest('[data-line]'), Number(e.target.value));
  });

  /* ---------- Quantity stepper on the product page ---------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var input = step.parentNode.querySelector('input');
    input.value = Math.max(1, (Number(input.value) || 1) + Number(step.getAttribute('data-qty-step')));
  });

  /* ---------- Product page: variants + gallery ---------- */
  (function () {
    var info = $('[data-product-info]');
    if (!info) return;
    var scope = info.closest('.pz-product');
    var variants = JSON.parse($('[data-variants]', info).textContent);
    var picker = $('[data-variant-picker]', info);
    if (!picker) return;

    function selectedOptions() {
      var values = [];
      $$('select[data-option-index]', picker).forEach(function (s) { values[Number(s.dataset.optionIndex)] = s.value; });
      $$('input[data-option-index]:checked', picker).forEach(function (r) { values[Number(r.dataset.optionIndex)] = r.value; });
      return values;
    }

    function update() {
      var selected = selectedOptions();
      var variant = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      });

      // Grey out pills with no in-stock variant, given the earlier choices.
      $$('input[data-option-index]', picker).forEach(function (input) {
        var idx = Number(input.dataset.optionIndex);
        var available = variants.some(function (v) {
          return v.available && v.options[idx] === input.value &&
            v.options.every(function (o, i) { return i >= idx || o === selected[i]; });
        });
        input.closest('.pz-chip').classList.toggle('is-unavailable', !available);
      });

      var button = $('[data-add-button]', info);
      if (!variant) {
        if (button) { button.disabled = true; button.textContent = PZ.strings.unavailable; }
        return;
      }
      var idInput = $('[data-variant-id]', info);
      if (idInput) idInput.value = variant.id;
      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available ? PZ.strings.addToCart : PZ.strings.soldOut;
      }

      var priceBlock = $('[data-price-block]', info);
      if (priceBlock) {
        var onSale = variant.compare_at_price > variant.price;
        $('[data-current-price]', priceBlock).textContent = formatMoney(variant.price);
        priceBlock.classList.toggle('pz-price--sale', onSale);
        var compare = $('[data-compare-price]', priceBlock);
        compare.hidden = !onSale;
        compare.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
      }

      var sku = $('[data-sku]', info);
      if (sku) sku.textContent = variant.sku || '';

      var stock = $('[data-stock]', info);
      if (stock) {
        stock.hidden = !variant.low_stock;
        if (variant.low_stock) stock.textContent = PZ.strings.lowStock.replace('[count]', variant.low_stock);
      }

      if (variant.featured_media) showMedia(scope, variant.featured_media);

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    picker.addEventListener('change', update);
    update();
  })();

  function showMedia(scope, mediaId) {
    var gallery = $('[data-gallery]', scope);
    if (!gallery) return;
    $$('.pz-gallery__slide', gallery).forEach(function (s) {
      var active = s.getAttribute('data-media-id') === String(mediaId);
      var video = $('video', s);
      if (!active && video) video.pause();
      s.classList.toggle('is-active', active);
    });
    $$('[data-thumb]', gallery).forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-thumb') === String(mediaId));
    });
  }

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (thumb) { showMedia(thumb.closest('.pz-product'), thumb.getAttribute('data-thumb')); return; }
    var zoom = e.target.closest('[data-lightbox-src]');
    if (zoom) { openLightbox(zoom.getAttribute('data-lightbox-src')); return; }
    if (e.target.closest('[data-lightbox-close]') || e.target.matches('[data-lightbox-img]')) closeLightbox();
  });

  function openLightbox(src) {
    var box = $('#Lightbox');
    $('[data-lightbox-img]', box).src = src;
    box.hidden = false;
    document.body.classList.add('pz-locked');
    $('[data-lightbox-close]', box).focus();
  }
  function closeLightbox() {
    var box = $('#Lightbox');
    if (!box || box.hidden) return;
    box.hidden = true;
    if (!openLayer) document.body.classList.remove('pz-locked');
  }

  /* ---------- Share: native share sheet, or copy the link ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-share-url]');
    if (!btn) return;
    var url = btn.getAttribute('data-share-url');
    if (navigator.share) {
      navigator.share({ title: btn.getAttribute('data-share-title'), url: url }).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () {
        var label = btn.lastChild;
        var original = label.textContent;
        label.textContent = btn.getAttribute('data-copied');
        setTimeout(function () { label.textContent = original; }, 2000);
      });
    }
  });

  /* ---------- Related products ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    fetch(el.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  });
})();
